import { gql } from '@apollo/client';

export interface DspWhsAndAreaDataType {
  trackingNumber: string;
  stopNumber: number;
  subStopNumber: string;
  isPickedUp: boolean;
  lastScannerName: string | null;
  allocationDriverName: string | null;
}

export interface DspWhsAndAreaAllDataType {
  parcelList: DspWhsAndAreaDataType[];
  assignedOrderCount: number | null;
}

export interface GetOrderDataOfCurrentDspAllWarehousesAndAllAreasResponse {
  getOrderDataOfCurrentDspAllWarehousesAndAllAreas: DspWhsAndAreaAllDataType;
}

export const GET_ORDER_DATA_OF_CURRENT_DSP_ALL_WAREHOUSES_AND_ALL_AREAS = gql`
  query DeliveryQuery($areaId: Long!, $warehouseId: Long) {
    getOrderDataOfCurrentDspAllWarehousesAndAllAreas(areaId: $areaId, warehouseId: $warehouseId) {
      parcelList {
        trackingNumber
        stopNumber
        subStopNumber
        isPickedUp
        lastScannerName
        allocationDriverName
      }
      assignedOrderCount
    }
  }
`;

